import React, { useEffect, useState, useContext } from "react";
import { useLocation, Outlet, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "react-alert";

import { Card, GrayCardTitle, SubCard, SubCardContainer, SubCardTitle, SessionsContainer, RightAlignedButton } from "../../common_components/Layout";
import { ExistingRequirements } from "../../create_mission_components/components/RequirementComponents";
import { SecondaryButton } from "../../common_components/Buttons";
import { AudienceGroupReadOnly } from "../../create_mission_components/components/RequirementComponents";
import { AudienceRequirementsIndividualCard } from "../../create_mission_components/components/AudienceRequirements";
import GeographyIcon from "../../../../../../../assets/images/researcher_app/create/audience_geography_icon.svg";
import DemographicIcon from "../../../../../../../assets/images/researcher_app/create/audience_demographic_icon.png";
import CryptoUsageIcon from "../../../../../../../assets/images/researcher_app/create/audience_crypto_usage_icon.png";
import OnChainIcon from "../../../../../../../assets/images/researcher_app/create/audience_on_chain_icon.png";


// Api Calls
import RequirementGroupsAPI from "../../../api/api_calls/RequirementGroupsAPI";
import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";
import FeatureFlag from "../../../../utility_components/FeatureFlag";


function RequirementsCard(props) {

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()
    const [loadingRequirements, setLoadingRequirements] = useState(true);
    const [requirementGroups, setRequirementGroups] = useState([]);

    const activeRequirements = requirementGroups[0] != null ? requirementGroups[0].full_requirement_list : null;
    const geographic_requirements = activeRequirements != null ? activeRequirements.geography : null;
    const demographic_requirements = activeRequirements != null ? activeRequirements.demographics : null;
    const crypto_usage_requirements = activeRequirements != null ? activeRequirements.crypto_usage : null;
    const wallet_requirements = activeRequirements != null ? activeRequirements.wallet : null;
    const requirementCount = (geographic_requirements !== null ? Object.keys(geographic_requirements).length : 0)
        + (demographic_requirements !== null ? Object.keys(demographic_requirements).length : 0)
        + (crypto_usage_requirements !== null ? Object.keys(crypto_usage_requirements).length : 0)
        + (wallet_requirements !== null ? Object.keys(wallet_requirements).length : 0);


    useEffect(() => {
        // Enable tooltips
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

        async function getRequirements() {
            const result = await RequirementGroupsAPI.index(missionId, navigate);

            if (result.success) {
                if (result.requirement_groups.length == 0) {
                } else {
                    setRequirementGroups(result.requirement_groups);
                }
                setLoadingRequirements(false);
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        getRequirements();
    }, []);

    return (
        <Card>
            <GrayCardTitle title="Audience" />
            {loadingRequirements ? <CenteredLoadingIcon /> :
                <>
                    <div className="mission-overview-card-text">
                        This mission has {requirementCount} audience requirement(s).
                    </div>
                    <RightAlignedButton>
                        <SecondaryButton onClick={() => navigate("/missions/" + missionId + "/requirements")} text="Edit" />
                    </RightAlignedButton>
                </>
            }
        </Card>

    )
}

export default RequirementsCard;